import { createContext, useContext } from 'react'

/**
 * DOM slots in the AppShell top bar. PageHeader portals the page title and actions into them so
 * every page shows one title row (crumb + title on the left, search / bell / actions on the right).
 */
export interface TopbarSlots {
  title: HTMLElement | null
  actions: HTMLElement | null
}

export const TopbarSlotsContext = createContext<TopbarSlots | null>(null)

export function useTopbarSlots(): TopbarSlots | null {
  return useContext(TopbarSlotsContext)
}
